import type { IScope } from "angular";
import { isNil } from "lodash";
import type { IPartnerUser, IPartnerUserSlim, ISite } from "App/Modules/Models";
import type { IAlarmHandlingInstruction } from "App/Modules/Models/Models/IAlarmHandlingInstruction";

export default class EditInstructionWithContactsComponentController {
    public static $inject: string[] = ["$scope"];

    public heading: string;
    public instruction: IAlarmHandlingInstruction;

    public site: ISite;

    constructor(private readonly $scope: IScope) {}

    public $onInit() {
        const unsub = this.$scope.$watch("$ctrl.instruction", (instruction: IAlarmHandlingInstruction) => {
            if (!instruction) {
                return;
            }

            instruction.contactPrimary = instruction.contactPrimary || ({} as IPartnerUser);
            instruction.contactSecondary = instruction.contactSecondary || ({} as IPartnerUser);

            unsub();
        });
    }

    public userPrimarySelected(user: IPartnerUserSlim) {
        if (isNil(user)) {
            this.instruction.contactPrimary = {} as IPartnerUser;
            return;
        }
        Object.assign(this.instruction.contactPrimary, user);
    }

    public userSecondarySelected(user: IPartnerUserSlim) {
        if (isNil(user)) {
            this.instruction.contactSecondary = {} as IPartnerUser;
            return;
        }
        Object.assign(this.instruction.contactSecondary, user);
    }
}
